import { TSetTokensInCookiesProps } from '../../types/cookie';
import { getCookie, removeCookie, setCookie } from '../cookie';
import { encrypt } from './crypto';

/**
 * 암호화된 accessToken과 refreshToken을 쿠키에 설정합니다.
 *
 * @param {string} accessToken - 'accessToken' 쿠키에 저장될 액세스 토큰
 * @param {string} refreshToken - 'refreshToken' 쿠키에 저장될 리프레시 토큰
 *
 * @returns {void}
 */
export const setTokensInCookies = ({ accessToken, refreshToken }: TSetTokensInCookiesProps) => {
  const cookieOptions: any = {
    path: '/' // 모든 페이지에서 쿠키 접근 가능
  };

  // accessToken을 암호화하여 쿠키에 설정
  setCookie({
    name: 'accessToken',
    // value: encrypt(accessToken),
    value: accessToken,
    options: cookieOptions
  });

  // refreshToken을 암호화하여 쿠키에 설정
  setCookie({
    name: 'refreshToken',
    // value: encrypt(refreshToken),
    value: refreshToken,
    options: cookieOptions
  });
};

/**
 * 암호화된 accessToken과 refreshToken을 쿠키에서 제거합니다.
 *
 * @returns {void}
 */
export const removeTokensFromCookies = (): void => {
  removeCookie({ name: 'accessToken', options: { path: '/' } });
  removeCookie({ name: 'refreshToken', options: { path: '/' } });
};

/**
 * 암호화된 accessToken을 쿠키에서 가져옵니다.
 *
 * @returns {string | null} - accessToken (쿠키가 없을 경우 null 반환)
 */
export const getAccessTokenFromCookies = (): string | null => {
  const accessToken = getCookie({ name: 'accessToken' }); // 쿠키에서 accessToken 가져옴
  if (!accessToken) return null;
  // 필요하면 복호화
  // return decrypt(accessToken);
  return accessToken; // 현재는 복호화 없이 바로 반환
};

/**
 * 암호화된 refreshToken을 쿠키에서 가져옵니다.
 *
 * @returns {string | null} - refreshToken (쿠키가 없을 경우 null 반환)
 */
export const getRefreshTokenFromCookies = (): string | null => {
  const refreshToken = getCookie({ name: 'refreshToken' }); // 쿠키에서 refreshToken 가져옴
  if (!refreshToken) return null;
  // 필요하면 복호화
  // return decrypt(refreshToken);
  return refreshToken; // 현재는 복호화 없이 바로 반환
};
